import React from "react";
import { bool, instanceOf, node } from "prop-types";
import CustomButton from "pages/_components/CustomButton/CustomButton";
// import { HeaderContext } from "./CompoundHeader";
import ToolbarItem from "./components/ToolbarItem";
import { resizableRoute as resizableComponent } from "../Resizable";

export const DesktopButtons = resizableComponent(
    ({ children, moreOptions, isDesktop, buttonExtra, secondButtonDisabled }) => {
        const hasOptions = moreOptions.length > 0;
        const startColumn = hasOptions ? 9 : 10;

        if (!isDesktop) {
            return null;
        }

        if (children.length) {
            return (
                <>
                    {buttonExtra
                        ? children.map((child, index) => (
                              <ToolbarItem
                                  key={`toolbar-item-${Date.now() + index}`}
                                  startColumn={
                                      (children.length - 1 - index === 0 && 12) ||
                                      (children.length - 1 - index === 1 && 9)
                                  }
                                  gridColumn={
                                      (children.length - 1 - index === 0 && 1) ||
                                      (children.length - 1 - index === 1 && 3)
                                  }>
                                  {child}
                              </ToolbarItem>
                          ))
                        : children.map((child, index) => (
                              <ToolbarItem
                                  key={`toolbar-item-${Date.now() + index}`}
                                  startColumn={startColumn - 3 * (children.length - 1 - index)}>
                                  {child}
                              </ToolbarItem>
                          ))}
                    {hasOptions && (
                        <ToolbarItem startColumn={12}>
                            <CustomButton
                                className="toolbar-item"
                                icon="images/figma/icon/menu-ios.svg"
                                pullRight
                                options={moreOptions}
                            />
                        </ToolbarItem>
                    )}
                </>
            );
        }

        if (secondButtonDisabled) {
            return (
                <>
                    <ToolbarItem startColumn={startColumn}>{children}</ToolbarItem>
                    {hasOptions && (
                        <ToolbarItem startColumn={12}>
                            <CustomButton
                                className="toolbar-item"
                                icon="images/figma/icon/menu-ios.svg"
                                pullRight
                                options={moreOptions}
                            />
                        </ToolbarItem>
                    )}
                </>
            );
        }

        return <ToolbarItem startColumn={startColumn}>{children}</ToolbarItem>;
    },
);

DesktopButtons.propTypes = {
    children: node,
    moreOptions: instanceOf(Array),
    isDesktop: bool.isRequired,
    secondButtonDisabled: bool,
};

DesktopButtons.defaultProps = {
    children: null,
    moreOptions: [],
    secondButtonDisabled: false,
};

export default DesktopButtons;
